import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import Slider from "@components/Slider"
import breakpoints from "@constants/breakpoints"
import React from "react"
import styled, { css } from "styled-components"

export const Container = styled.div<{ portraitMode?: boolean }>`
  ${({ portraitMode }) => css`
    ${ImageHelperContainer} {
      display: inline-block;
      width: ${portraitMode ? "75vw" : "85vw"};
      height: ${portraitMode ? "calc(75vw * 1.5)" : "85vw"};
      margin-right: 8px;
      > div {
        display: inline-block;
        padding-bottom: 0 !important;
      }
      img {
        max-height: 100%;
        object-fit: cover !important;
      }

      @media ${breakpoints.tablet} {
        width: ${portraitMode
          ? "calc(((8 / 9 + 10) / 12 * 100vw) * 0.667)"
          : "calc((8 / 9 + 10) / 12 * 100vw)"};
        height: calc((8 / 9 + 10) / 12 * 100vw);
        margin-right: 16px;
      }

      @media ${breakpoints.laptop} {
        width: ${portraitMode
          ? "calc(4.5 / 12 * 100vw)"
          : "calc(10.5 / 12 * 100vw)"};
        height: ${portraitMode
          ? "calc(4.5 / 12 * 100vw * 1.5)"
          : "calc(10.5 / 12 * 100vw * 0.5)"};
        margin-right: 0;
      }
    }
  `}
`

interface ImageSliderProps {
  blockId?: string
  images: Array<string>
  portraitMode?: boolean
}

const ImageSlider: React.FC<ImageSliderProps> = ({
  blockId,
  images,
  portraitMode,
}) => {
  return (
    <Container id={blockId || undefined} portraitMode={portraitMode}>
      <Slider portraitMode={portraitMode} slideCount={images.length}>
        {images.map((item) => {
          return <ImageHelper key={item} src={item} />
        })}
      </Slider>
    </Container>
  )
}

export default ImageSlider
